function t(key) {
  const path = key.split('.')
  let translation = window.Site.locales;

  for (let part of path) {
    if (translation)
    translation = translation[part]
  }

  return translation || path[path.length - 1]
}

export {
  t
}